import { useEffect } from 'react';
import { useFormikContext } from 'formik';

import TextField from '@mui/material/TextField';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../../hooks/useGraphQLQuery.hook';
import { getTouchedError } from '../../../../utils/get-touched-error.util';

import type { UserFormValues } from '../../types/user-form-values.type';

export const UserForm_PersonEmail_Query = graphql(`
  query UserForm_PersonEmail_Query($id: Id!) {
    findOnePerson(id: $id) {
      _id
      contactInfo {
        _id
        email
      }
    }
  }
`);

interface Props {
  readonly id: string;
}

// eslint-disable-next-line no-empty-pattern
export const UserEmailFormStep = ({}: Readonly<Props>) => {
  const { errors, handleBlur, handleChange, setFieldValue, touched, values } =
    useFormikContext<UserFormValues>();

  const { data } = useGraphQLQuery(
    UserForm_PersonEmail_Query,
    { id: values.personId },
    { enabled: !!values.personId && !values.email },
  );

  // The contact email of the person, unless one is already typed.
  const contactEmail = data?.findOnePerson.contactInfo?.email;

  useEffect(() => {
    if (contactEmail && !values.email) {
      void setFieldValue('email', contactEmail);
    }
  }, [contactEmail, setFieldValue, values.email]);

  return (
    <TextField
      autoComplete="off"
      error={!!(errors.email && touched.email)}
      fullWidth
      helperText={getTouchedError(errors, touched, 'email')}
      id="user-email"
      label="Adresse e-mail"
      name="email"
      onBlur={handleBlur}
      onChange={handleChange}
      required
      sx={{ mt: 1 }}
      type="email"
      value={values.email}
    />
  );
};
